/**
 * @class Language
 */
export default class Language {
    /**
     * @param {String}          code
     * @param {String}          name
     * @param {String}          nativeName
     * @param {Boolean}         custom
     * @param {String | null}   country
     * @param {Array | null}    locales
     */
    constructor(code, name, nativeName, custom, country = null, locales = null) {
        this._code = code;
        this._name = name;
        this._nativeName = nativeName;
        this._custom = custom;
        this._country = country === null ? code : country;
        this._locales = locales;
    }

    /**
     * @return {String}
     */
    get code() {
        return this._code;
    }

    /**
     * @param {String} code
     */
    set code(code) {
        this._code = code;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {Boolean}
     */
    get custom() {
        return this._custom;
    }

    /**
     * @param {Boolean} custom
     */
    set custom(custom) {
        this._custom = custom;
    }

    /**
     * @return {String}
     */
    get nativeName() {
        return this._nativeName;
    }

    /**
     * @param {String} nativeName
     */
    set nativeName(nativeName) {
        this._nativeName = nativeName;
    }

    /**
     * @return {String}
     */
    get country() {
        return this._country;
    }

    /**
     * @param {String} country
     */
    set country(country) {
        this._country = country;
    }

    /**
     * @return {Array | null}
     */
    get locales() {
        return this._locales;
    }

    /**
     * @param {Array | null}    locales
     */
    set locales(locales) {
        this._locales = locales;
    }

    /**
     * @param {String}  code
     */
    compareTo = (code) => {
        if (this._code === code) {
            return true;
        }

        if (this._locales === null) {
            return false;
        }

        return this._locales.some((locale) => locale.code === code);
    };
}
